import React, { useCallback, useEffect, useRef, useState } from "react";
import { Checkbox, Col, Modal, Row } from "antd";

import {
  BASE_URL,
  AddStaff,
  UploadFile,
  FetchDepartment,
  FetchDesignation,
  FetchShifts,
  FetchLocation,
  STAFF_ROLE,
  FetchStaff,
  UpdateStaff,
} from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { CameraOutlined } from "@ant-design/icons";
import moment from "moment";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
const StaffDetail = ({ open, onCancel }) => {
  const [staffDetail, setStaffDetail] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);

  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  useEffect(() => {
    getStaffList();
  }, []);

  const getStaffList = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({ roles: [STAFF_ROLE.All] }),
        });

        if (response.ok) {
          const data = await response.json();
          const activeStaff = data.data.filter((item) => item.isActive);
          setStaffDetail(activeStaff);
        } else {
          const data = await response.json();
          console.log("stafferr", data);
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      };
      await fetchData();
    } catch (error) {
      console.error("Error updating designation:", error);
    }
  };

  const columnDefs = [
    {
      headerName: "Profile",
      field: "profile",

      flex: 1,
      cellRenderer: (params) => {
        return (
          <>
            <div className="">
              <div className="flex items-center">
                <div>
                  <img
                    className="hisimage min-w-[47px] min-h-[47px] w-[47px] h-[47px] rounded-full"
                    src={params.data.item.faceRegisterUrl}
                    alt=""
                  />
                </div>
                <div className="pl-[12px]">
                  <p className="text-base !font-sbold">
                    {capitalizeFirstLetter(params.data.item.firstName)} {capitalizeFirstLetter(params.data.item.lastName)}
                  </p>
                  <p className="text-sm">
                    {capitalizeFirstLetter(
                      params.data.item.designation.designationName
                    )}
                  </p>
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Add",
      field: "add",
      flex: 1,
      cellRenderer: (params) => {
        return (
          <Checkbox
            className="assign-att-take my-0"
            checked={params.data?.item?.isInList}
            onChange={(e) =>
              handleCheckboxChange(
                params?.data?.item,
                "attendanceTaker",
                e.target.checked
              )
            }
          ></Checkbox>
        );
      },
    },
  ];

  const data = staffDetail
    ?.filter((item) => item?.isStaffBo == false)
    .map((item, index) => {
      return {
        key: index,
        item: item,
        profile: item.firstName,
      };
    });

  const handleCheckboxChange = (params, field, checked) => {
    updateStaff(checked, params?._id);
  };

  const updateStaff = async (checked, staffRoleId) => {
    const token = localStorage.getItem("authToken");
    const data = {
      _id: staffRoleId,
      isInList: checked,
    };
    try {
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${UpdateStaff}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          const data = await response.json();
          getStaffList();
        } else {
          const data = await response.json();
          console.log("stafferr", data);
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      };
      await fetchData();
    } catch (error) {
      console.error("Error updating designation:", error);
    }
  };
  return (
    <Modal
      title="Staff"
      open={open}
      okButtonProps={{ style: { background: "grey" } }}
      onCancel={onCancel}
      footer={null}
    >
      <ToastContainer position="top-right" autoClose={2000} />
      <input
        type="text"
        id="filter-text-box"
        className="border-bottom w-full text-base mx-2 outline-none"
        placeholder="Search..."
        onInput={onFilterTextBoxChanged}
      />
      <div
        className="ag-theme-alpine text-base footer-12 border-none font-proxima"
        style={{ height: "auto", width: "100%", marginTop: "10px" }}
      >
        <AgGridReact
          ref={gridRef}
          gridOptions={gridOptions}
          columnDefs={columnDefs}
          rowData={data}
          domLayout="autoHeight"
          onGridReady={(params) => setGridApi(params.api)}
          pagination={true}
          getRowHeight={() => 60}
          paginationPageSize={20}
          paginationPageSizeSelector={false}
        />
      </div>
    </Modal>
  );
};

export default StaffDetail;
